var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconManager38Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Haldus",
    transform: "translate(-240.000000, -1505.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(240.000000, 1505.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5638852,-1.03584031e-16 L35.4361148,1.03584031e-16 C36.3276335,-6.01853049e-17 36.6509198,0.0928256111 36.9768457,0.267132704 C37.3027716,0.441439796 37.5585602,0.697228371 37.7328673,1.0231543 C37.9071744,1.34908022 38,1.67236646 38,2.5638852 L38,35.4361148 C38,36.3276335 37.9071744,36.6509198 37.7328673,36.9768457 C37.5585602,37.3027716 37.3027716,37.5585602 36.9768457,37.7328673 C36.6509198,37.9071744 36.3276335,38 35.4361148,38 L2.5638852,38 C1.67236646,38 1.34908022,37.9071744 1.0231543,37.7328673 C0.697228371,37.5585602 0.441439796,37.3027716 0.267132704,36.9768457 C0.0928256111,36.6509198 4.01235366e-17,36.3276335 -6.90560205e-17,35.4361148 L6.90560205e-17,2.5638852 C-4.01235366e-17,1.67236646 0.0928256111,1.34908022 0.267132704,1.0231543 C0.441439796,0.697228371 0.697228371,0.441439796 1.0231543,0.267132704 C1.34908022,0.0928256111 1.67236646,6.01853049e-17 2.5638852,-1.03584031e-16 Z",
    id: "Rectangle",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "headphones-customer-support",
    transform: "translate(11.000000, 11.000000)",
    stroke: "#FFCD00",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,12 L2.5,12 C1.3954305,12 0.5,11.1045695 0.5,10 L0.5,8 C0.5,6.8954305 1.3954305,6 2.5,6 L3,6 C3.27614237,6 3.5,6.22385763 3.5,6.5 L3.5,11.5 C3.5,11.7761424 3.27614237,12 3,12 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,12 L13,12 C12.7238576,12 12.5,11.7761424 12.5,11.5 L12.5,6.5 C12.5,6.22385763 12.7238576,6 13,6 L13.5,6 C14.6045695,6 15.5,6.8954305 15.5,8 L15.5,10 C15.5,11.1045695 14.6045695,12 13.5,12 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,6 C2.5,2.96243388 4.96243388,0.5 8,0.5 L8,0.5 C9.45869069,0.5 10.8576372,1.07946262 11.8890873,2.1109127 C12.9205374,3.14236278 13.5,4.54130931 13.5,6",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,14.5 L11.5,14.5 C12.6045695,14.5 13.5,13.6045695 13.5,12.5 L13.5,12.5 L13.5,12",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,15.5 L8,15.5 C7.44771525,15.5 7,15.0522847 7,14.5 L7,14.5 C7,13.9477153 7.44771525,13.5 8,13.5 L9,13.5 C9.55228475,13.5 10,13.9477153 10,14.5 L10,14.5 C10,15.0522847 9.55228475,15.5 9,15.5 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManager38Px);
export default __webpack_public_path__ + "static/media/Icon_Manager-38px.22752c7f84252943bd80225fd9f633b3.svg";
export { ForwardRef as ReactComponent };